export default __webpack_public_path__ + "static/media/img-17.058eef58.jpg";